import React from "react";
import { Tabs, Tab, Box } from "@mui/material";
import { useTranslation } from "react-i18next"; // <-- 1. Importamos el hook

interface BlogHeaderProps {
  activeTab: "Temas CG" | "Noticias IT";
  setActiveTab: (tab: "Temas CG" | "Noticias IT") => void;
}

const BlogHeader: React.FC<BlogHeaderProps> = ({ activeTab, setActiveTab }) => {
  const { t } = useTranslation(); // <-- 2. Inicializamos la traducción

  const handleChange = (
    event: React.SyntheticEvent,
    newValue: "Temas CG" | "Noticias IT",
  ) => {
    setActiveTab(newValue);
  };

  return (
    <Box
      sx={{
        borderBottom: "2px solid #f1f5f9",
        marginBottom: "30px",
        display: "flex",
        justifyContent: { xs: "center", sm: "flex-start" },
      }}
    >
      <Tabs
        value={activeTab}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        sx={{
          "& .MuiTabs-indicator": {
            backgroundColor: "#0069a7",
            height: "4px",
          },
        }}
      >
        <Tab
          label={t("blog.tabs.temasCG")} // <-- 3. Traducimos el texto visual
          value="Temas CG" // <-- Mantenemos el valor lógico intacto
          disableRipple
          sx={{
            fontSize: "1.5rem",
            fontWeight: 700,
            textTransform: "none",
            color: "#64748b",
            "&.Mui-selected": {
              color: "#0069a7",
            },
            "&:hover": {
              color: "#0069a7",
            },
            minWidth: "auto",
            padding: "0 20px",
            paddingBottom: "10px",
            marginRight: { xs: 0, sm: "20px" },
          }}
        />
        <Tab
          label={t("blog.tabs.noticiasIT")} // <-- 4. Traducimos el texto visual
          value="Noticias IT" // <-- Mantenemos el valor lógico intacto
          disableRipple
          sx={{
            fontSize: "1.5rem",
            fontWeight: 700,
            textTransform: "none",
            color: "#64748b",
            "&.Mui-selected": {
              color: "#0069a7",
            },
            "&:hover": {
              color: "#0069a7",
            },
            minWidth: "auto",
            padding: "0 20px",
            paddingBottom: "10px",
          }}
        />
      </Tabs>
    </Box>
  );
};

export default BlogHeader;
